import { links } from 'src/router/routes';

export const menu = [
  { icon: 'dashboard', label: 'Dashboard', link: links.dashboard },
  {
    icon: 'devices',
    label: 'Devices',
    link: links.devices,
    links: [{ label: 'My Devices', link: links.devices }],
  },
  {
    icon: 'interactions',
    label: 'Interactions',
    link: links.interactions,
    links: [
      { label: 'My Interactions', link: links.interactions },
      { label: 'Repository', link: links.interactionsDictionary },
      { label: 'Add new', link: links.interactionNew },
    ],
  },
  {
    icon: 'campaigns',
    label: 'Campaigns',
    link: links.campaigns,
    links: [
      { label: 'Add New', link: links.campaignNew },
      { label: 'My Campaigns', link: links.campaigns },
    ],
  },
  {
    icon: 'branding',
    label: 'Branding',
    link: links.brandings,
    links: [
      { label: 'My Brands', link: links.brandings },
      { label: 'Add New', link: links.brandingNew },
    ],
  },
];
